var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7 7.001v10.36a1 1 0 0 0 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69l-8.14-5.17a1 1 0 0 0-1.54.84"}})])}
var staticRenderFns = []

export { render, staticRenderFns }